module.exports = __webpack_public_path__ + "img/antes_despues_30.1eda6d21.png";